import { useMapGetter } from 'dashboard/composables/store';
import {
  canOpenConversation as canOpenConversationHelper,
  getAgentOpenConversationInInbox as getAgentOpenConversationInInboxHelper,
  isRestrictionEnabledForConversation,
} from 'dashboard/helper/agentSingleConversationRestriction';

export function useAgentSingleConversationRestriction() {
  const currentUser = useMapGetter('getCurrentUser');
  const inboxesList = useMapGetter('inboxes/getInboxes');
  const chatLists = useMapGetter('getAllConversations');
  const currentChat = useMapGetter('getSelectedChat');

  const buildContext = () => ({
    conversations: chatLists.value,
    inboxes: inboxesList.value,
    currentUserId: currentUser.value?.id,
    currentChat: currentChat.value,
  });

  const getAgentOpenConversationInInbox = inboxId =>
    getAgentOpenConversationInInboxHelper({
      inboxId,
      ...buildContext(),
    });

  const canOpenConversation = conversation =>
    canOpenConversationHelper({
      conversation,
      ...buildContext(),
    });

  return {
    canOpenConversation,
    getAgentOpenConversationInInbox,
    isRestrictionEnabled: conversation =>
      isRestrictionEnabledForConversation(conversation, inboxesList.value),
  };
}
